import React from 'react';
import { normalizeRole } from '../utils/roles';

const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5001';

const getAvatarUrl = (employee) => {
  if (employee?.avatar?.filePath) {
    return `${apiUrl}/${employee.avatar.filePath.replace(/\\/g, '/')}`;
  }

  return null;
};

const getInitials = (employee) =>
  `${employee?.firstName?.charAt(0) || ''}${employee?.lastName?.charAt(0) || ''}`.toUpperCase();

const formatDate = (value) => {
  if (!value) {
    return '-';
  }

  return new Date(value).toLocaleDateString('tr-TR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
};

const EmployeeDetailModal = ({ employee, isOpen, onClose }) => {
  if (!isOpen || !employee) {
    return null;
  }

  const avatarUrl = getAvatarUrl(employee);
  const expertise = Array.isArray(employee.expertise) ? employee.expertise.filter(Boolean) : [];

  return (
    <>
      <div className="modal-backdrop fade show" onClick={onClose}></div>
      <div className="modal fade show d-block" tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content directory-modal">
            <div className="modal-header border-0 pb-0">
              <div>
                <h5 className="modal-title">Çalışan Profili</h5>
                <p className="text-muted mb-0">Onaylı rehber kaydı ve iletişim detayları</p>
              </div>
              <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
            </div>

            <div className="modal-body">
              <div className="row g-4">
                <div className="col-md-4">
                  <div className="directory-modal-profile">
                    <div className="directory-modal-avatar">
                      {avatarUrl ? (
                        <img src={avatarUrl} alt={`${employee.firstName} ${employee.lastName}`} />
                      ) : (
                        <div className="directory-modal-avatar-fallback">{getInitials(employee)}</div>
                      )}
                    </div>
                    <h4>{employee.firstName} {employee.lastName}</h4>
                    <p>{employee.position}</p>
                    <span className="badge bg-light text-dark">{employee.department}</span>
                    {employee.company && (
                      <span className="badge bg-light text-dark mt-2">{employee.company}</span>
                    )}
                  </div>
                </div>

                <div className="col-md-8">
                  <div className="row g-3">
                    <div className="col-md-6">
                      <div className="directory-modal-field">
                        <small>E-posta</small>
                        <a href={`mailto:${employee.email}`}>{employee.email}</a>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="directory-modal-field">
                        <small>Telefon</small>
                        <span>{employee.phone || '-'}</span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="directory-modal-field">
                        <small>Dahili numara</small>
                        <span>{employee.extension || '-'}</span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="directory-modal-field">
                        <small>Lokasyon</small>
                        <span>{employee.officeLocation || '-'}</span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="directory-modal-field">
                        <small>İşe başlangıç</small>
                        <span>{formatDate(employee.startDate)}</span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="directory-modal-field">
                        <small>Rol</small>
                        <span>{normalizeRole(employee.role) === 'super_admin' ? 'Yönetici' : normalizeRole(employee.role) === 'company_admin' ? 'Müdür' : 'Çalışan'}</span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="directory-modal-field">
                        <small>Şirket</small>
                        <span>{employee.company || '-'}</span>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="directory-modal-field">
                        <small>Kısa biyografi</small>
                        <p className="mb-0">{employee.bio || 'Bu çalışan için henüz biyografi eklenmemiş.'}</p>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="directory-modal-field">
                        <small>Uzmanlık alanları</small>
                        <div className="directory-modal-tags">
                          {expertise.length > 0 ? (
                            expertise.map((item) => (
                              <span key={item} className="directory-modal-tag">
                                {item}
                              </span>
                            ))
                          ) : (
                            <span className="text-muted">Tanımlı uzmanlık alanı bulunmuyor.</span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer border-0">
              <a className="btn btn-primary" href={`mailto:${employee.email}`}>
                E-posta gönder
              </a>
              {employee.phone && (
                <a className="btn btn-outline-primary" href={`tel:${employee.phone}`}>
                  Telefon et
                </a>
              )}
              <button type="button" className="btn btn-secondary" onClick={onClose}>
                Kapat
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmployeeDetailModal;

